/**
 * A rubber stamp being struck: it arrives large and light and lands on the
 * paper (life-layer.md §3 P1: `.stamp` scale 1.7 → 1, opacity, 0.32 s,
 * `back.out(1.4)`).
 *
 * Owns: the one slam. Must not: decide when a stamp is due — callers use
 * `StampSlam.vue` for a stamp that appears with a `v-if`, or call this for
 * one that is already in the DOM. Under reduced motion it leaves the stamp
 * as it is.
 */
import { playCue } from '@/audio/sfx';

import { enter } from './gsap';

const SLAM = { scale: 1.7, opacity: 0, duration: 0.32, ease: 'back.out(1.4)' };

export function slamStamp(el: Element, done?: () => void, delay = 0): void {
  // The sound is the strike: it goes when the stamp lands, not when it leaves the hand.
  enter(el, { ...SLAM, delay }, () => {
    playCue(el.classList.contains('seal') ? 'reward.seal' : 'reward.stamp');
    done?.();
  });
}

/**
 * Slam every stamp on a sheet that carries `data-stamp="<id>"`: the card that
 * just became OWNED, the node that was just RESEARCHED. Call it after the
 * DOM has caught up (`await nextTick()`); the swap has already happened, the
 * slam is what makes it a stamp being struck rather than text changing.
 */
export function slamStampsFor(root: ParentNode | null, id: string): void {
  root?.querySelectorAll(`[data-stamp="${id}"]`).forEach((el) => slamStamp(el));
}
